import { getBrazeInstance, flushAndAwaitAuthResult } from "./brazeSdk";

export type CreateAnonymousBrazeUserOptions = {
  email: string;
  anonymousId: string;
  awaitAuthResult?: boolean;
  flushTimeoutMs?: number;
};

export const createAnonymousBrazeUser = async ({
  email,
  anonymousId,
  awaitAuthResult = false,
  flushTimeoutMs,
}: CreateAnonymousBrazeUserOptions): Promise<void> => {
  if (!email || !anonymousId) {
    throw new Error("Email and anonymousId are required");
  }
  const braze = getBrazeInstance();
  if (!braze) throw new Error("Braze instance not found");
  const user = braze.getUser();
  if (!user) throw new Error("Braze user not found");

  user.addAlias(anonymousId, "anonymousId");
  user.setEmail(email);
  user.setCustomUserAttribute(
    "asos_marketing_anonymous_backinstock_opted_in",
    true
  );

  if (awaitAuthResult) {
    await flushAndAwaitAuthResult(braze, flushTimeoutMs);
    return;
  }

  braze.requestImmediateDataFlush();
};
